import React from "react";

const MongoDBIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 255.995 255.995"
    >
      <g
        fill="none"
        strokeMiterlimit="10"
        fontFamily="none"
        fontSize="none"
        fontWeight="none"
        textAnchor="none"
        style={{ mixBlendMode: "normal" }}
      >
        <path
          fill="#001e2b"
          d="M26 32H6a6 6 0 01-6-6V6a6 6 0 016-6h20a6 6 0 016 6v20a6 6 0 01-6 6z"
          transform="scale(8)"
        ></path>
        <path
          fill="#00ed64"
          d="M15.923 8c-.001.013-.003.021-.003.033v.009h-.001l-.003.026v.01h-.001l-.001.017v.017h-.002l-.002.017v.014h-.001l-.001.014v.013h-.001l-.001.021v.001l-.006.033v.005h-.001l-.002.008v.011h-.002v.015h-.003v.012h-.003v.014h-.003v.013h-.006v.011h-.004v.009h-.003v.012h-.003v.009h-.003v.009h-.002v.01h-.003l-.001.003v.007h-.002l-.001.004v.004h-.001l-.001.007-.007.014v.001c-.001.001-.003.003-.003.005v.005h-.003v.005h-.003v.005h-.002v.007h-.004v.009h-.003v.003h-.003v.005h-.003v.007h-.003v.005h-.004v.007h-.003v.005h-.003v.005h-.002v.007h-.003v.005h-.003v.004h-.003v.005h-.004v.006h-.003v.004h-.003v.005h-.003v.007h-.003v.003h-.002v.005h-.004v.003h-.003v.007h-.003v.003h-.003v.005h-.003v.004h-.002l-.001.003v.003h-.001l-.001.003v.001h-.001l-.003.005v.002h-.001l-.008.012v.001c-.001.001-.005.004-.006.007v.001h-.001l-.002.004v.002h-.001l-.002.002v.001h-.001l-.002.003v.003h-.002l-.001.001v.001h-.001l-.001.002v.002h-.003l-.001.002v.004h-.002v.003h-.003v.003h-.003v.005h-.003V8.62h-.003v.003h-.003v.004h-.003v.005H15.7v.003h-.003v.004h-.003v.003h-.003v.005h-.004v.003h-.003v.004h-.003v.003h-.003v.003h-.003v.007h-.001v.003h-.004v.003h-.003v.001h-.003v.003h-.003v.007h-.003v.003h-.003v.003h-.003v.004h-.003v.003h-.003V8.7h-.006v.007h-.003v.003h-.004v.003h-.003v.003h-.003v.004h-.003v.003h-.003v.005h-.003v.003h-.004v.004h-.001v.003h-.003v.003h-.003v.003h-.003v.004H15.6v.003h-.002l-.001.001v.001h-.001l-.003.003-.003.002v.004h-.003v.003h-.003v.003h-.003v.003h-.002V8.77v.002h-.001l-.001.001v.002h-.001c-.003.004-.005.007-.01.011l-.008.007-.027.021-.015.011v.001h-.001a.95.95 0 01-.033.026v.001l-.05.041v-.001h-.001c-.039.031-.08.067-.127.106V9h-.001a7.172 7.172 0 00-.405.379l-.013.013c-.927.938-2.387 2.893-2.541 6.051a6.68 6.68 0 00.004.763v.006a7.156 7.156 0 00.973 3.171v.001c.199.344.414.657.631.937v.001a8.643 8.643 0 001.713 1.684c.3.682.273 1.853.273 1.853l.437.141s-.089-1.134.036-1.681c.039-.171.131-.317.238-.441a5.8 5.8 0 00.543-.43l.03-.036c1.037-.945 2.973-3.273 2.309-7.066-.861-3.707-2.891-4.925-3.109-5.391-.24-.329-.499-.955-.499-.955z"
          transform="scale(8)"
        ></path>
      </g>
    </svg>
  );
};

export default MongoDBIcon;
